import { type PermissionType } from '@terros/common'

export const CONNECT_VIEW_PERMISSIONS: readonly PermissionType[] = ['install:manage', 'app:manage']

export const INTEGRATION_MANAGE_PERMISSIONS: readonly PermissionType[] = [
  'export:manage',
  'apikey:manage',
  'webhook:manage',
]

export type IntegrationsAccess = {
  isConnectLoading: boolean
  hasConnectAccess: boolean
  isAdmin: boolean
  canManageIntegrations: boolean
  isTerrosMcpEnabled: boolean
  isTerrosMcpLoading: boolean
}

export const isIntegrationsVisible = (access: IntegrationsAccess): boolean => {
  // TerrosMCP has no permission of its own. The Integrations parent has to show for the
  // same people who could open it from Settings, or the move would hide it from them.
  if (access.isTerrosMcpLoading) return true
  if (access.isTerrosMcpEnabled) return true
  if (access.isConnectLoading) return true
  if (access.hasConnectAccess) return true
  if (access.isAdmin) return true
  return access.canManageIntegrations
}
